import { useTranslation } from 'next-i18next';
import { ReactElement } from 'react';
import * as React from 'react';
import ReactToPrint from 'react-to-print';

import 'react-datepicker/dist/react-datepicker.min.css';

import { Button, NextImage, Typography } from '@/shared/components/atoms';
import ModalOverlay from '@/shared/components/molecules/ModalOverlay';
import SingleQrCode from '@/shared/components/molecules/SingleQrCode';

interface IQrCodeModal {
  // variant: 'single' | 'multiple';
  open: boolean;
  closeModal: () => void;
  qrData: {
    qrCode: string | undefined;
    logo?: string;
    name?: string;
    title?: string;
  };
}

export default function QrCodeModal({
  // variant = 'single',
  open,
  closeModal,
  qrData,
}: IQrCodeModal): ReactElement {
  const { t } = useTranslation('common');
  const qrcodeRef = React.useRef(null);

  return (
    <ModalOverlay
      modalPosition='center'
      title={t('qrCode')}
      open={open}
      closeModal={closeModal}
    >
      {/* ***************** modal wrapper **************** */}
      <div className='flex flex-col items-center border-t-sm border-neutralVariant-90 pt-32'>
        <div className='mb-24 w-464'>
          <Typography className='mb-32 w-full text-surface-10'>
            {t('qr-code-description')}
          </Typography>
          <Typography
            variant='h3'
            weight='bold'
            className='w-full text-black'
            style={{ textAlign: 'center' }}
          >
            {qrData?.name}
          </Typography>
          <div className='mt-8 flex justify-center'>
            <NextImage
              priority
              height={200}
              width={200}
              useSkeleton
              src={qrData.qrCode || ''}
              alt='qr code'
            />
          </div>
          <div className='hidden'>
            <SingleQrCode ref={qrcodeRef} qrData={qrData} />
          </div>
        </div>
        {/* ******** print btn ******** */}
        <ReactToPrint
          content={() => qrcodeRef.current}
          trigger={() => (
            <Button size='full' className='py-2 !text-base'>
              {t('print')}
            </Button>
          )}
        />
      </div>
    </ModalOverlay>
  );
}
